module.exports = __webpack_public_path__ + "static/led-screen-d-c2153a129728e42400b837c4123a2398.jpg";